export const Routes = {
        Presentation: { path: "/" },
        DashboardOverview: { path: "/dashboard/overview" },
        Transactions: { path: "/transactions" },
        ManagePayments: { path: "/dashboard/manage-payments" },
        Settings: { path: "/settings" },
        Upgrade: { path: "/upgrade" },
        BootstrapTables: { path: "/tables/bootstrap-tables" },
        ManageProducts: { path: "/dashboard/manage-products" },
        ManageCategory: { path: "/dashboard/manage-categories" },
        ManageHomePage: { path: "/dashboard/manage-home-page" },
    ManageCustomField: { path: "/dashboard/manage-custom-fields" },
    ManageCommands: { path: "/dashboard/manage-commands" },
    ManageOccasions: { path: "/dashboard/manage-occasions" },
    ManageGiftCards: { path: "/dashboard/manage-gift-cards" },
    ManageTags: { path: "/dashboard/manage-tags" },
    ManageUsers: { path: "/dashboard/manage-users" },
    ManageAdmins: { path: "/dashboard/manage-admins" },
        NotFound: { path: "/notfound" },
        ServerError: { path: "/server-error" },
        Login: { path: "/login" },
        Register: { path: "/register" },
        AdminRegister: { path: "/admin-register" },
        AdminLogin: { path: "/admin-login" },
        
    };